export const isValidTime = (time: string | undefined) => {
  if (!time) return true
  if (time.length === 0) return true
  if (time.length !== 8) return false
  const arr = [...time]
  const isTimeCorrect = (arr: string[]) => {
    if (Number(arr[0] + arr[1]) >= 24) return false
    if (Number(arr[3] + arr[4]) >= 60) return false
    if (Number(arr[6] + arr[7]) >= 60) return false
    if (arr[2] !== ':') return false
    if (arr[5] !== ':') return false
    return true
  }
  return isTimeCorrect(arr)
}
